<template>
  <v-container
    class="cancellable-trades-container"
    fluid
  >
    <h1>Cancellable trades</h1>
    <CancellableTrades
      v-if="trades"
      :trades="trades"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { CancellableTrades } from '@/components/trades';

export default {
  name: 'CancellableTradesView',
  components: {
    CancellableTrades,
  },
  computed: {
    ...mapState({
      loading: state => state.cancellableTradesStore.loading,
      trades: state => state.cancellableTradesStore.trades.map(trade => ({
        ...trade,
        offer: trade.sell_offer ? trade.sell_offer : trade.buy_offer,
        offer_type: trade.sell_offer ? 'Sell offer' : 'Buy offer',
      })),
    }),
  },
  async mounted() {
    this.fetchCancellableTrades(toQueryString(this.$route.query));
  },
  methods: {
    ...mapActions(['fetchCancellableTrades']),
  },
};
</script>


<style lang="scss" scoped>
.cancellable-trades-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/CancellableTradesView.vue